import { Endpoint } from '@business/api/endpoint';
import { Button } from '@core/components/Button';
import { FlashMessage } from '@core/components/FlashMessage';
import { FormCheckbox, FormContainer, FormInput } from '@core/components/form';
import { useHistory, useQueryStringParam } from '@core/router';
import { AppConfig } from '@core/utils/config';
import { Styles } from '@core/utils/css';
import { useFormConfig, useFormState } from '@core/utils/form';
import { useDidMount } from '@core/utils/hooks/react';
import { R } from '@core/utils/r';
import { tapError } from '@core/utils/rxjs/operators';
import { Session } from '@modules/auth/session';
import React, { Fragment, memo, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { t } from 'ttag';
import { defineLoginForm, LoginFormData } from './LoginForm';
import { PublicDashboardHeader } from '@modules/main/PublicDashboardHeader';

export const LoginPage = memo(() => {
  const form = useMemo(() => defineLoginForm(), []);

  const redirectUrl = useQueryStringParam('redirectUrl');

  useDidMount(() => {
    AppConfig.set({ appId: '', companyId: '' });
    Endpoint.setAppId(null);
    Endpoint.setCompanyId(null);
  });

  const onSubmit = useCallback(
    (data: LoginFormData) => {
      return of(null).pipe(
        switchMap(() => {
          if (R.isEmpty(AppConfig.current().appId)) {
            return Session.loginWithAccounts(
              {
                username: data.email,
                password: data.password,
              },
              data.remember,
              redirectUrl,
            );
          } else {
            return Session.login(
              {
                username: data.email,
                password: data.password,
              },
              data.remember,
              redirectUrl,
            );
          }
        }),
        tapError(error => {
          FlashMessage.error(error, t`Email and password do not match`);
        }),
      );
    },
    [redirectUrl],
  );

  useFormConfig(form, { onSubmit });

  const { submitting } = useFormState(form, { submitting: true });

  return (
    <Fragment>
      <PublicDashboardHeader />
      <div style={{ backgroundColor: '#fff', height: '100vh' }} className="account-pages overflow-hidden">
        <Container fluid style={{ height: '100vh' }}>
          <Row className="justify-content-center" style={{ height: '100vh' }}>
            <Col md={6} className="align-self-center">
              <div className="p-2 overflow-hidden mt-3">
                {/* <AvForm className="form-horizontal"> */}
                <h2 className="text-primary">Login now</h2>
                <p className="text-muted mb-5 font-size-12">Please enter the details below to continue.</p>
                <FormContainer onSubmit={form.submit}>
                  <FormInput control={form.controls.email} />
                  <FormInput type="password" control={form.controls.password} />
                  <div className="mb-3">
                    <FormCheckbox control={form.controls.remember} noPadding inline />
                    <div className="d-inline float-right">
                      <Link to="/reset-password" className="text-muted">
                        <i className="mdi mdi-lock mr-1" />
                        Forgot your password?
                      </Link>
                    </div>
                  </div>
                  <div className="submit mt-2">
                    <Button type="submit" intent="primary" loading={submitting} icon="fa fa-arrow-right">
                      Sign In
                    </Button>
                  </div>
                </FormContainer>
              </div>
            </Col>
            <Col md={6} className="align-self-center">
              <div className="text-center card-inverse">
                <img className="justify-content-center align-middle" src={Styles.assets('images/login-img.png')} style={{ height: '75vh' }} alt="" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
});
